/**
 * "How this is worked out", on every report card: a few plain sentences for
 * whoever reads the pack, closed until asked for.
 *
 * The report's own text comes first. A report with none, one built from
 * scratch, gets a plain description made from what it counts and filters.
 */
export function howItWorksLines(result) {
  const written = String(result?.how_it_works || "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
  if (written.length) return written;

  const lines = [];
  if (result?.method?.length) return result.method;
  if (result?.filter_description) {
    lines.push(`Counts the records that match: ${result.filter_description}.`);
  }
  if (result?.group_by_label) {
    lines.push(`Split by ${result.group_by_label}.`);
  }
  if (result?.value_kind === "sum" && result?.value_property_label) {
    lines.push(`The figures are ${result.value_property_label}, added up.`);
  }
  return lines;
}

export default function HowItWorks({ result }) {
  const lines = howItWorksLines(result);
  if (!lines.length) return null;
  return (
    <details
      className="mt-4 rounded border border-[#efefef] bg-[#f5f5f5] px-3 py-2 print:hidden"
      data-testid="how-it-works"
    >
      <summary className="cursor-pointer text-xs font-semibold text-[#4a5b68]">How this is worked out</summary>
      <ul className="mt-2 list-disc space-y-1.5 pl-4">
        {lines.map((line) => (
          <li key={line} className="text-xs leading-relaxed text-[#323c44]">{line}</li>
        ))}
      </ul>
    </details>
  );
}
